module.exports = __webpack_public_path__ + "img/icone-signes.4355e2e2.png";